import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { apiErrorMessageKey } from '../../../lib/api';
import { useSetPasswordMutation } from '../../../lib/auth';
import { SetPasswordForm } from '../components/SetPasswordForm';

export function ResetPasswordPage({ otp }: { otp: string }): ReactElement {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const mutation = useSetPasswordMutation();

    return (
        <Stack spacing={4}>
            <Stack spacing={1}>
                <Typography variant="h5" component="h1">
                    {t('AUTH.RESET_PASSWORD.TITLE')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {t('AUTH.RESET_PASSWORD.DESCRIPTION')}
                </Typography>
            </Stack>

            <SetPasswordForm
                submitLabel={t('AUTH.RESET_PASSWORD.SUBMIT')}
                isPending={mutation.isPending}
                errorMessage={
                    mutation.error ? t(apiErrorMessageKey(mutation.error, 'ERRORS.RESET_PASSWORD_FAILED')) : undefined
                }
                onSubmit={(password) =>
                    mutation.mutate({ otp, password }, { onSuccess: () => void navigate({ to: '/' }) })
                }
            />
        </Stack>
    );
}
